import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import 'antd/dist/antd.css';

import CreditCardAuthorization from './pages/CreditCardAuthorization';
import './global.scss';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_API_KEY);

const App = () => (
  <Elements stripe={stripePromise}>
    <Switch>
      <Route path="/customers/credit-card-authorization">
        <CreditCardAuthorization />
      </Route>
    </Switch>
  </Elements>
);

export default App;
